import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Typography } from '@mui/material';
import ConfirmationModal from './components/confirmation.modal';
import { useSnackbar } from '../../../shared/components/snackbar/Snackbar';
import { ISnackbarContextType } from '../../../shared/models';
import { SnackbarEnum } from '../../../shared/enum';
import { rateFeeData } from '../../../shared/context/rateFeeContext';
import { LogsUtility } from '../../../shared/utilities/logs.utility';
import { IUserActivityLogs } from '../../../shared/models/logs.model';
import { ActivityLogsContext } from '../../../shared/context/logsContext';

const columns: GridColDef<(any)[number]>[] = [
  {
    field: 'id',
    headerName: 'Index',
    width: 60,
    headerAlign: 'center',
    align: 'center',
    filterable: true,
    sortable: true,
    hideable: false
  },
  {
    field: 'uniqueWithoutProduct',
    headerName: 'Unique without product',
    width: 220,
    headerAlign: 'center',
    align: 'center',
    editable: false,
  },
  {
    field: 'propertyUsage',
    headerName: 'Property usage',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
  },
  {
    field: 'repaymentType',
    headerName: 'Repayment type',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
  },
  {
    field: 'interestType',
    headerName: 'Interest type',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
  },
  {
    field: 'product',
    headerName: 'Product',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
  },
  // {
  //   field: 'docType',
  //   headerName: 'Doc type',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  // },
  // {
  //   field: 'lvr',
  //   headerName: 'LVR',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  // },
  {
    field: 'lvrRange',
    headerName: 'LVR range',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
  },
  {
    field: 'borrowerRate',
    headerName: 'Borrower rate',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
    type: 'number',
    valueGetter: (val: any, row: any) => {
      return (Number(val ?? 0) - Number(row.discount ?? 0))?.toFixed(2);
    },
    valueFormatter: (params: any,) => `${(Number(params ?? 0))?.toFixed(2)}`,
    // valueParser: (val: any, row: any) => {
    //   return val > 100 ? 100 : val      
    // },
  },
  // {
  //   field: 'comparisonRate',
  //   headerName: 'Comparison rate',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)?.toFixed(2)}`
  // },
  // {
  //   field: 'offsetBorrowerRate',
  //   headerName: 'Offset Borrower rate',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)?.toFixed(2)}`
  // },
  // {
  //   field: 'offsetComparisonRate',
  //   headerName: 'Offset Comparison rate',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)?.toFixed(2)}`
  // },
  {
    field: 'baseRate',
    headerName: 'Base rate',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: false,
    type: 'number',
    valueFormatter: (params: any) => `${(Number(params ?? 0))?.toFixed(2)}`
  },
  {
    field: 'discount',
    headerName: 'Discount',
    width: 180,
    headerAlign: 'center',
    align: 'center',
    editable: true,
    type: 'number',
    valueFormatter: (params: any) => `${(Number(params ?? 0))?.toFixed(2)}`
  },
  // {
  //   field: 'dataEntryAdditionalMargin',
  //   headerName: 'Data entry additional margin',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)?.toFixed(2)}`
  // },
  // {
  //   field: 'residencyLoading',
  //   headerName: 'Residency loading',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)}%`
  // },
  // {
  //   field: 'politicallyExposed',
  //   headerName: 'Politically exposed',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)}%`
  // },
  // {
  //   field: 'highRiskCountries',
  //   headerName: 'High risk countries (FATF)',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)}%`
  // },
  // {
  //   field: 'facilityTypeLoading',
  //   headerName: 'Facility type loading',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)}%`
  // },
  // {
  //   field: 'managerDiscretion',
  //   headerName: 'Manager discretion',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `${(params ?? 0)?.toFixed(2)}`
  // },
  // {
  //   field: 'monthlyFee',
  //   headerName: 'Monthly fee',
  //   width: 180,
  //   headerAlign: 'center',
  //   align: 'center',
  //   editable: false,
  //   type: 'number',
  //   valueFormatter: (params: any) => `$${(params)?.toFixed(2)}`
  // },
];

const findChangedValue = (newRow: any, oldRow: any) => {
  for (let key in newRow) {
    if (newRow[key] !== oldRow[key]) {
      return key; // Return the changed field name (or the changed value if needed)
    }
  }
  return null;
}

export default function DataGridDemo() {
  const logs = React.useContext(ActivityLogsContext as any);
  const data = JSON.parse(sessionStorage.getItem('rateFee') as string) ? JSON.parse(sessionStorage.getItem('rateFee') as string) as any[] : rateFeeData;
  const { showSnackbar } = useSnackbar() as ISnackbarContextType;
  const [isConfirmationModel, setConfirmationModal] = React.useState(false);
  const [selectedRowData, setSelectRowData] = React.useState({ newRow: null, oldRow: null });
  const [rows, setRows] = React.useState(data.map((row, index) => { return { ...row, id: index + 1 } }));
  const handleCloseConfirmationModal = (isClose: boolean) => {
    let index = selectedRowData.newRow ? rows.findIndex(item => item.id === (selectedRowData.newRow as any)?.id) : -1;
    if (index !== -1 && isClose) {
      let updatedRows = [...rows];
      updatedRows[index] = (selectedRowData.newRow as any);
      // let updatedProperty = findChangedValue(selectedRowData.newRow, selectedRowData.oldRow);
      // console.log(`User has updated the ${updatedProperty} form ${((selectedRowData.oldRow as any)[updatedProperty as keyof {}]) ?? 0} to ${((selectedRowData.newRow as any)[updatedProperty as keyof {}]) ?? 0}`);

      const updatedRow = (JSON.parse(sessionStorage.getItem('rateFee') as string) ? JSON.parse(sessionStorage.getItem('rateFee') as string) as any[] : rateFeeData)?.map((el) =>
        (el?.propertyUsage?.toString() === (selectedRowData.newRow as any)?.propertyUsage?.toString() &&
          el?.lvrRange?.toString() === (selectedRowData.newRow as any)?.lvrRange?.toString() &&
          el?.repaymentType?.toString() === (selectedRowData.newRow as any)?.repaymentType?.toString() &&
          el?.interestType?.toString() === (selectedRowData.newRow as any)?.interestType?.toString()) ?
          { ...el, discount: (selectedRowData.newRow as any)?.discount } : el
      );

      sessionStorage.setItem('rateFee', JSON.stringify(updatedRow))

      let currentLog = new LogsUtility().updateUserLogs(
        { name: '', userEmail: '' },
        {},
        'event' as any,
        'id',
        'customerID',
        { description: `Mukesh salaria has updated the Discount from ${Number((selectedRowData.oldRow as any)?.discount ?? 0)?.toFixed(2) ?? 0} to ${Number((selectedRowData.newRow as any)?.discount ?? 0)?.toFixed(2) ?? 0} where scenario is <b>${(selectedRowData.newRow as any).uniqueWithoutProduct}</b>.` }
        // {description: `Mukesh salaria has updated the ${handlePropertyName(updatedProperty as string)} from ${Number((selectedRowData.oldRow as any)[updatedProperty as keyof {}])?.toFixed(2) ?? 0} to ${Number((selectedRowData.newRow as any)[updatedProperty as keyof {}])?.toFixed(2) ?? 0}`}
      )
      const updatedLogs: IUserActivityLogs[] = JSON.parse(sessionStorage.getItem('activityLogs') as string) ?? logs;
      updatedLogs.unshift(currentLog)

      sessionStorage.setItem('activityLogs', JSON.stringify(updatedLogs));
      // console.log(updatedRow);

      setRows(updatedRows);
      showSnackbar(
        "Record updated successfully",
        SnackbarEnum.Success,
      );
    }
    if (!isClose) {
      setRows(rows);
    }
    setConfirmationModal(false);
  };

  const handleProcessRowUpdate = (newRow: any, oldRow: any, isModalClose: boolean = false) => {
    let updatedProperty = findChangedValue(newRow, oldRow);
    setSelectRowData({ newRow, oldRow });
    if (updatedProperty) {
      setConfirmationModal(true);
    }
    return oldRow;
  }

  const handleCellKeyDown = (params: any, event: React.KeyboardEvent<HTMLElement>) => {
    const allowedCharacters = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'Backspace',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      '.'
    ]
    if (!allowedCharacters.includes(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <Box component={'section'} p={3} bgcolor={"#f5f5f5"} height={"100%"}>
      {/* <Typography variant="body1" color="initial" bgcolor={"transparent"} fontWeight={'bold'} mb={2}>
        Admin
      </Typography> */}
      {/* <Box sx={{ width: '100%', bgcolor: "#fff", borderRadius: 2, boxShadow: 2, p: 3 }}> */}
        <Typography variant="h5" color="primary" mb={2} fontWeight={600}>
          Rate & Fees
        </Typography>
         {/* height 636px */}
        <DataGrid
          sx={{
            borderRadius: 1.5, bgcolor: "#fff", height: "684px",
            '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#ebedf3', // Customize with your desired color
          },
            '& .MuiDataGrid-cell, & .MuiDataGrid-cell.MuiDataGrid-cell--editing, & .MuiDataGrid-columnHeader': {
              '&focus, &:focus-within': {
                outlineOffset: "-2px"
              }
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            },
            '& input[type=number]': {
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                // '-webkit-appearance': 'none',
                appearance: 'none'
              },
              mozAppearance: 'textfield',
              width: '100%',
              textAlign: 'center',
            },
          }}
          showCellVerticalBorder
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[5, 10, 20, 25, 50]}
          onCellKeyDown={(params: any, event: React.KeyboardEvent<HTMLElement>) => handleCellKeyDown(params, event)}
          processRowUpdate={(newRow, oldRow) => handleProcessRowUpdate(newRow, oldRow)}
        />
      {/* </Box> */}
      <ConfirmationModal open={isConfirmationModel} handleClose={(isClose) => handleCloseConfirmationModal(isClose)} />
    </Box>
  );
}



